"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var moment_1 = __importDefault(require("moment"));
var RatingPopup = /** @class */ (function (_super) {
    __extends(RatingPopup, _super);
    function RatingPopup(props) {
        return _super.call(this, props) || this;
    }
    RatingPopup.prototype.render = function () {
        var _a = this.props, ratings = _a.ratings, ratingsLoading = _a.ratingsLoading, closeRatingModal = _a.closeRatingModal, ratingModalShow = _a.ratingModalShow;
        //TODO : Maps warning
        return ((0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Modal, __assign({ onClose: ratingModalShow, open: ratingModalShow, className: "ratingModalList" }, { children: [(0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Modal.Header, { children: ["Ratings", (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, __assign({ floated: "right", className: "cancel-button loginCloseBtn", icon: true, basic: true, onClick: closeRatingModal }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Icon, { name: "close" }) }))] }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Modal.Content, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Modal.Description, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid, __assign({ columns: 3, divided: true }, { children: (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.GridRow, { children: [ratingsLoading && ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Loader, { active: true, intermediate: true })), ratings.map(function (item) { return ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.GridColumn, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: 'ratingRepScore' }, { children: [(0, jsx_runtime_1.jsx)("div", { className: 'userAvatar', style: { backgroundImage: "url(".concat(item.avatar, ")") } }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: 'userDetails' }, { children: [(0, jsx_runtime_1.jsx)("h6", { children: (0, jsx_runtime_1.jsx)("span", __assign({ class: "username" }, { children: item.username })) }), (0, jsx_runtime_1.jsxs)("p", { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Rating, { icon: 'star', defaultRating: item.rating, maxRating: 5, disabled: true }), (0, jsx_runtime_1.jsx)("span", { className: 'dots' }), item.hours_ago && moment_1.default.utc(new Date(item.hours_ago * 1000)).local().fromNow().replace(/\w+[.!?]?$/, '')] })] }))] })) })); })] }) })) }) })] })));
    };
    return RatingPopup;
}(react_1.Component));
exports.default = RatingPopup;
